import { render, staticRenderFns } from "./single-upload.vue?vue&type=template&id=60fe11f6&scoped=true&"
import script from "./single-upload.vue?vue&type=script&lang=js&"
export * from "./single-upload.vue?vue&type=script&lang=js&"
import style0 from "./single-upload.vue?vue&type=style&index=0&id=60fe11f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60fe11f6",
  null
  
)

export default component.exports